/**
 * <PresenterFloorShadow />
 *
 * A soft, blurred contact-shadow ellipse rendered at a presenter's feet so
 * he reads as standing ON the floor plane rather than floating as a flat
 * cutout. Every room's key light comes from the top-left (window / desk
 * lamps baked into the backgrounds), so the shadow is offset toward the
 * bottom-right to match.
 *
 * Meant to be rendered as the FIRST child inside a presenter's positioned
 * wrapper (before the <img>), anchored to the wrapper's own bottom edge —
 * it then inherits the same left/bottom/height animation as the presenter
 * and never needs its own position math.
 */
export function PresenterFloorShadow({
  width = "58%",
  height = "7%",
  offsetX = "9%",
  bottom = "6.2%",
  opacity = 0.34,
  blur = 6,
}) {
  return (
    <div
      aria-hidden="true"
      data-testid="presenter-floor-shadow"
      className="absolute left-1/2"
      style={{
        width,
        height,
        bottom,
        transform: `translateX(calc(-50% + ${offsetX}))`,
        background:
          "radial-gradient(ellipse at center, rgba(10,7,4,0.62) 0%, rgba(10,7,4,0.26) 48%, rgba(10,7,4,0) 78%)",
        filter: `blur(${blur}px)`,
        opacity,
        pointerEvents: "none",
      }}
    />
  );
}

export default PresenterFloorShadow;
